import { Box, DialogContent, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { DialogCloseButton } from '../../../components/DialogCloseButton';
import {
  SupplementalFilesCheckByGroupScopedGrid,
  SupplementalFilesTransitionScopedGrid,
} from './SupplementalFilesGrid';
import {
  CreateSupplementalFilesModalForCheckByGroup,
  CreateSupplementalFilesModalForTransition,
} from './CreateSupplementalFilesModal';
import { FlexTableBox } from '../../../components/FlexTableBox';
import { AuthorizedSection } from '../../../auth/AuthorizedSection';
import { PersistentDialog } from '../../../components/PersistentDialog';

export interface BaseModalProps {
  id: string;
  title: string;
  onClose: () => void;
}

export interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  createSupplementalFileModal: React.ReactNode;
}

export const SupplementalFilesTransitionScopedModal = ({ id, onClose, title }: BaseModalProps) => {
  const [refreshTrigger, setRefreshTrigger] = useState<boolean>(true);

  return (
    <Modal
      onClose={onClose}
      title={title}
      createSupplementalFileModal={
        <CreateSupplementalFilesModalForTransition
          id={id}
          onClose={(hasChanges: boolean) => {
            if (hasChanges) {
              setRefreshTrigger(!refreshTrigger);
            }
          }}
        />
      }
    >
      <SupplementalFilesTransitionScopedGrid id={id} refreshTrigger={refreshTrigger} />
    </Modal>
  );
};

export const SupplementalFilesCheckByGroupScopedModal = ({ id, onClose, title }: BaseModalProps) => {
  const [refreshTrigger, setRefreshTrigger] = useState<boolean>(true);

  return (
    <Modal
      onClose={onClose}
      title={title}
      createSupplementalFileModal={
        <CreateSupplementalFilesModalForCheckByGroup
          id={id}
          onClose={(hasChanges: boolean) => {
            if (hasChanges) {
              setRefreshTrigger(!refreshTrigger);
            }
          }}
        />
      }
    >
      <SupplementalFilesCheckByGroupScopedGrid id={id} refreshTrigger={refreshTrigger} />
    </Modal>
  );
};

const Modal = ({ title, onClose, children, createSupplementalFileModal }: ModalProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(true);

  const handleClose = async () => {
    setModalOpen(false);
    onClose();
  };

  return (
    <>
      <PersistentDialog maxWidth={'md'} fullWidth onClose={handleClose} open={modalOpen}>
        <DialogTitle sx={{ minWidth: '300px', paddingBottom: 0 }}>
          <DialogCloseButton onClick={() => handleClose()} />
          {title}
        </DialogTitle>
        <DialogContent sx={{ height: '30vh' }}>
          <FlexTableBox>
            <AuthorizedSection hasSampleTrackingWriteAccess>
              <Box mb={1} display='flex' justifyContent='right'>
                {createSupplementalFileModal}
              </Box>
            </AuthorizedSection>
            {children}
          </FlexTableBox>
        </DialogContent>
      </PersistentDialog>
    </>
  );
};
